import styled, { keyframes } from 'styled-components';

export const chatbotZIndex = 9999;
export const chatbotPopupZIndex = chatbotZIndex + 1000;

export const Container = styled.div`
    position: fixed;
    z-index: ${chatbotZIndex};
    cursor: initial;
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0rem;
    gap: 1.6rem;
    border-radius: 3rem 3rem 3rem 3rem;
`;

export const InfoHint = styled.div`
    width: 1.2rem;
    height: 1.2rem;

    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 900;
    margin-left: -3rem;
    margin-top: -2rem;

    top: auto;

    color: #ffffff;
`;

export const Pokey = styled.div<{ $upright: boolean }>`
    position: absolute;
    display: flex;
    left: 25.3rem;
    bottom: auto;
    margin-bottom: -4.8rem;
    z-index: 99999;
    transform: ${(props) =>
        props.$upright ? 'translateX(-50%);' : 'rotateX(180deg) translateX(-50%);'};
    width: 0rem;
    height: 0rem;
    border-left: 1.6rem solid transparent;
    border-right: 1.6rem solid transparent;
    border-top: 1.6rem solid #ffffff;
`;

export const HintText = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1rem;
    isolation: isolate;
    z-index: 99999;
    overflow: auto;
    position: fixed;
    left: 14rem;
    margin-bottom: -10.8rem;
    bottom: auto;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #273d5a;
    width: 22.5rem;
    height: auto;
    background: #ffffff;
    box-shadow: 0rem 1rem 1.8rem rgba(9, 30, 66, 0.35),
        0rem 0rem 0.1rem rgba(9, 30, 66, 0.61);
    border-radius: 0.8rem;

    ${InfoHint}:hover & {
        visibility: visible;
        opacity: 1;
    }
`;

export const TextBoxContainer = styled.div<{
    $expanded: boolean;
    $drawerExpanded: boolean;
    $footerExpanded: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    left: ${(props) => (props.$drawerExpanded ? '32rem' : '8rem')};
    bottom: ${(props) => (props.$footerExpanded ? '-16.5rem' : '0rem')};
    height: 56.4rem;
    justify-content: flex-end;
    overflow: hidden;
    transition: width 0.5s ease-in-out, left 0.3s ease-in-out, bottom 0.3s ease-out;

    width: ${(props) => (props.$expanded ? '86.8rem' : '40rem')};
    z-index: 9998;

    background: #ffffff;

    box-shadow: 0rem 1rem 1.8rem rgba(9, 30, 66, 0.15),
        0rem 0rem 0.1rem rgba(9, 30, 66, 0.31);
    border-radius: 0.8rem;
`;

export const TitleBar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.2rem;
    isolation: isolate;
    justify-content: flex-start;
    overflow: hidden;
    position: absolute;
    z-index: 9999;

    width: 100%;
    height: 7.2rem;
    top: 0;

    background: #4470db;
    border-radius: 0.8rem 0.8rem 0rem 0rem;

    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
`;

export const TitleText = styled.div`
    width: 9.7rem;
    height: 2.4rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2.4rem;

    color: #ffffff;
`;

export const TextInputContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1.2rem;
    justify-content: flex;
    border-radius: 0rem 0rem 0.8rem 0.8rem;
    position: relative;
    bottom: 0rem;

    width: auto;
    height: auto;
    overflow-y: auto;

    background: #e9ecf2;

    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;
    z-index: 9998;
`;

export const TextInput = styled.textarea`
    flex: 1;
    margin-right: 1rem;
    margin-left: 1.5rem;
    margin-top: 1.2rem;
    margin-bottom: 1.2rem;
    z-index: 9998;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;
    padding-left: 0.5rem;

    color: #000000;

    box-sizing: border-box;

    width: 33.6rem;
    min-height: 2rem;
    height: auto;
    max-height: 12rem;
    overflow-y: auto;
    resize: none;

    background: #fafbfc;

    border: 0.2rem solid #dfe1e6;
    border-radius: 0.3rem;

    &:focus {
        outline: none;
    }

    &::placeholder {
        color: #999; // or any other lighter gray color you prefer
    }
`;

export const TypingBubbleAnimation = keyframes`
  0% {
    opacity: 0.3;
  }
  25% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  75% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.1;
  }
`;

export const TypingBubble = styled.span`
    display: inline-block;
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    background-color: #6c7c97;
    animation: ${TypingBubbleAnimation} 2s infinite;
    animation-delay: 1s;
`;

export const SendButton = styled.button`
    width: 2rem;
    height: 2rem;

    font-family: 'Font Awesome 5 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 2rem;
    line-height: 2rem;
    border: none;
    position: relative;
    margin-right: 2.5rem;
    margin-left: -1.5rem;

    color: #4470db;

    flex: none;
    order: 1;
    flex-grow: 0;

    &:hover&:enabled {
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.9);
    }
    &:disabled {
        color: #ccc;
    }
`;

export const HeaderButton = styled.div`
    width: 1.4rem;
    height: 2rem;

    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 1.4rem;
    line-height: 2rem;

    text-align: right;
    position: absolute;

    top: 40%;
    right: 4rem;

    color: #ffffff;

    flex: none;
    order: 2;
    flex-grow: 0;

    &:hover {
        transform: scale(1.1);
        cursor: pointer;
    }

    &:active {
        transform: scale(0.9);
    }
`;

export const ToolTip = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0rem 0.6rem;
    white-space: nowrap;
    bottom: 54rem;

    width: auto;
    height: 2rem;

    background: #ffffff;
    box-shadow: 0rem 0.3rem 0.5rem rgba(9, 30, 66, 0.2),
        0rem 0rem 0.1rem rgba(9, 30, 66, 0.31);
    border-radius: 0.3rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #273d5a;
    z-index: 999999;

    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const BubbleContainer = styled.span`
    display: flex;
    height: 100%;
    flex-direction: column-reverse;
    justify-content: flex-start;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    position: relative;
    flex-shrink: 1;
    margin-top: 7.5rem;
`;

export const UserMessage = styled.div`
    display: flex;
    justify-content: flex-start;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    color: #273d5a;

    width: auto;
    height: auto;

    overflow-wrap: break-word;
    overflow: hidden;
    hyphens: auto;
    word-break: break-word;
`;

export const UserBubble = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.6rem 3.2rem;
    gap: 1.6rem;
    margin: 0.5rem 1.6rem 1.5rem 1.6rem;
    transition: left 0.2s ease-in-out;

    max-width: 89%;
    height: auto;
    width: auto;

    background: #e9ecf2;
    border-radius: 0.8rem;

    position: relative;
`;

export const RegenContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: none;
    margin-top: 1.5rem;
    position: relative;
`;

export const RegenButton = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0.2rem 1.2rem;
    position: relative;
    margin: 0rem 2rem;
    overflow-scroll: none;

    width: 17.4rem;
    height: 2.4rem;
    background: rgba(9, 30, 66, 0.04);

    border-radius: 0.5rem;
    border: 0rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #273d5a;
    box-sizing: content-box;
    z-index: 9999;
    flex-shrink: 0;

    transition: background-color 0.3s ease;

    &:hover {
        background-color: rgba(9, 30, 66, 0.2);
        cursor: pointer;
    }

    &:active {
        transform: scale(0.98);
    }
`;

export const RegenText = styled.div`
    width: 15rem;
    height: 2rem;
    margin-right: -0.5rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2rem;

    display: flex;
    align-items: center;
    text-align: center;

    color: #273d5a;
`;

export const BotMessage = styled.div`
    display: flex;
    justify-content: flex-start;
    flex-basis: 77%;
    flex-grow: 1;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;

    color: #273d5a;

    width: auto;
    height: auto;
    overflow-wrap: break-word;
    overflow: hidden;
    word-break: break-word;
    margin-right: 1rem;
    white-space: pre-line;
`;

export const BotBubble = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.6rem 1.6rem;
    gap: 1.6rem;
    margin: 0.5rem 1.6rem 1.5rem 1.6rem;
    flex-wrap: wrap;

    height: auto;
    width: auto;
    max-width: 93%;

    background: #f5f5f5;
    border-radius: 0.8rem;
    position: relative;
`;

export const CircleIcon = styled.div`
    justify-content: center;
    display: inline-flex;
    align-items: center;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    left: calc(50% - 36rem / 2);
    top: calc(50% - 12rem / 2);
    margin-left: 3rem;

    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 900;
    font-size: 1.8rem;
    line-height: 2rem;

    color: #4470db;
    background-color: #ffffff;
`;

export const BotIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    padding: 0.3rem 0.3rem;
    margin-left: 1rem;

    position: relative;
    width: 3.2rem;
    height: 3.2rem;
    left: 0rem;
    top: 0rem;

    background: #6c7c97;
    border-radius: 50%;

    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2rem;

    color: #ffffff;
    flex-shrink: 0;
`;

export const UserIcon = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
    padding: 0.3rem 0.3rem;
    margin-right: -0.2rem;
    margin-left: -0.5rem;

    position: relative;
    width: 3.2rem;
    height: 3.2rem;
    left: 0rem;
    top: 0rem;

    background: #4470db;
    border-radius: 50%;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;
    color: #ffffff;

    flex-shrink: 0;
`;

export const MessageTimestamp = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 0.3rem 0.3rem;
    margin-left: 2rem;
    margin-top: -1rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 2rem;
    color: #6c7c97;
`;

export const HoverTimestamp = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0rem 0.6rem;
    white-space: nowrap;

    position: absolute;
    width: auto;
    height: 2rem;
    right: 2rem;
    margin-top: -4rem;

    background: #ffffff;
    box-shadow: 0rem 0.3rem 0.5rem rgba(9, 30, 66, 0.2),
        0rem 0rem 0.1rem rgba(9, 30, 66, 0.31);
    border-radius: 0.3rem;

    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #273d5a;
    z-index: ${chatbotPopupZIndex - 2};

    flex: none;
    order: 0;
    flex-grow: 0;
`;

export const BottomDiv = styled.div`
    display: flex;
    height: 1rem;
    width: 100%;
`;

export const FeedbackButton = styled.button`
    display: inline-block;
    padding: 0.6rem 0.6rem;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    margin-right: 0.5rem;

    border-radius: 0.5rem;
    border: 0px;
    background: rgba(0, 0, 0, 0.07);

    color: #273d5a;
    font-family: Font Awesome 6 Pro;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;

    &:disabled {
        color: #4470db;
    }

    &:hover&:enabled {
        cursor: pointer;
    }
`;

export const FeedbackPopupBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    align-self: stretch;
    background: #fff;
    color: #1b212c;
    font-family: Lato;
    font-size: 1.3rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25rem;
`;

export const FeedbackPopupInput = styled.textarea`
    display: flex;
    width: 47.5rem;
    height: 5.5rem;
    padding: 0.5rem;
    justify-content: center;
    align-items: center;
    border-radius: 0.1875rem;
    border: 2px solid #dfe1e6;
    background: #f4f5f7;
    resize: none;
    scrollx: hidden;
    scrolly: auto;
    outline: none;
`;
